module.exports = __webpack_public_path__ + "img/add-sub-event-icon.88250898.svg";